module.exports = __webpack_public_path__ + "static/media/crowd-of-users.fbf52886.svg";